import React, { useState } from "react";
import {
  ApprovalType,
  BaseLogo,
  getApprovalBorderColor,
} from "../../../core/models/entities/BaseLogo";
import { LogoImage } from "../../components/Logo/LogoImage";
import { ApprovalStatus } from "../../../core/models/entities/Approval";

interface MultiLogoApprovalCarouselProps {
  logos: BaseLogo[];
  onSelectLogo: (logo: BaseLogo, index: number) => void;
  selectedIndex: number;
  approvalType?: ApprovalType;
}

interface LogoCarouselItemProps {
  logo: BaseLogo;
  isSelected: boolean;
  onClick: () => void;
  approvalType?: ApprovalType;
}

function LogoCarouselItem({
  logo,
  isSelected,
  onClick,
  approvalType,
}: LogoCarouselItemProps) {
  // Determine border color based on ApprovalType-specific status
  const borderColorClass = getApprovalBorderColor(logo.approval, approvalType);

  return (
    <div
      className={`relative min-w-[130px] min-h-[85px] w-[130px] h-[85px] rounded-sm border-solid bg-white text-gray-600 hover:cursor-pointer ${
        isSelected
          ? `${borderColorClass} shadow-sm`
          : `${borderColorClass} bg-white hover:opacity-80`
      }`}
      onClick={onClick}
    >
      <div className="flex justify-center items-center h-full p-4">
        <LogoImage
          className="w-full h-full object-contain"
          logo={logo}
          useHighRes={false}
        />
      </div>
    </div>
  );
}

export function MultiLogoApprovalCarousel({
  logos,
  onSelectLogo,
  selectedIndex,
  approvalType,
}: MultiLogoApprovalCarouselProps) {
  const logoItems = logos.map((logo, index) => (
    <LogoCarouselItem
      key={index}
      logo={logo}
      isSelected={index === selectedIndex}
      onClick={() => onSelectLogo(logo, index)}
      approvalType={approvalType}
    />
  ));

  return (
    <div>
      <p className="uppercase text-xs font-semibold pb-1.5">
        LOGOS ({logos.length})
      </p>
      <div className="flex space-x-1.5 overflow-x-auto overflow-y-hidden pt-1.5 mt-[-6px] pb-1 my-1 relative pr-1.5">
        {logoItems}
      </div>
    </div>
  );
}
